export const baseURL = 'https://nmgyy.qzkj.vip';
// export const baseURL = 'https://test.qzkj.vip';